var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf",
    "data-name": "Unbenannter Verlauf",
    x1: 14.984,
    y1: 256.679,
    x2: 15.04,
    y2: 256.51,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#510000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    "data-name": "Unbenannter Verlauf 2",
    x1: 14.981,
    y1: 256.717,
    x2: 15.025,
    y2: 256.6,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    "data-name": "Unbenannter Verlauf 3",
    x1: 13.335,
    y1: 257.661,
    x2: 19.032,
    y2: 257.661,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    "data-name": "Unbenannter Verlauf 4",
    x1: 13.335,
    y1: 258.741,
    x2: 19.032,
    y2: 258.741,
    gradientTransform: "translate(0 -243.113)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    "data-name": "Unbenannter Verlauf 5",
    x1: 13.335,
    y1: 259.824,
    x2: 19.032,
    y2: 259.824,
    gradientTransform: "translate(0 -244.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    "data-name": "Unbenannter Verlauf 6",
    x1: 13.335,
    y1: 260.905,
    x2: 19.032,
    y2: 260.905,
    gradientTransform: "translate(0 -245.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_7",
    "data-name": "Unbenannter Verlauf 7",
    x1: 13.335,
    y1: 261.984,
    x2: 19.032,
    y2: 261.984,
    gradientTransform: "translate(0 -246.457)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8",
    "data-name": "Unbenannter Verlauf 8",
    x1: 13.335,
    y1: 263.068,
    x2: 19.032,
    y2: 263.068,
    gradientTransform: "translate(0 -247.574)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_9",
    "data-name": "Unbenannter Verlauf 9",
    x1: 13.335,
    y1: 264.151,
    x2: 19.032,
    y2: 264.151,
    gradientTransform: "translate(0 -248.691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_10",
    "data-name": "Unbenannter Verlauf 10",
    x1: 13.335,
    y1: 265.231,
    x2: 19.032,
    y2: 265.231,
    gradientTransform: "translate(0 -249.804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_11",
    "data-name": "Unbenannter Verlauf 11",
    x1: 13.335,
    y1: 266.314,
    x2: 19.032,
    y2: 266.314,
    gradientTransform: "translate(0 -250.921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12",
    "data-name": "Unbenannter Verlauf 12",
    x1: 13.335,
    y1: 257.301,
    x2: 19.032,
    y2: 257.301,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_13",
    "data-name": "Unbenannter Verlauf 13",
    x1: 15.855,
    y1: 257.351,
    x2: 15.855,
    y2: 257.529,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_14",
    "data-name": "Unbenannter Verlauf 14",
    x1: 30.735,
    y1: 257.351,
    x2: 30.735,
    y2: 257.529,
    gradientTransform: "translate(-15.341 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_15",
    "data-name": "Unbenannter Verlauf 15",
    x1: 15,
    y1: 257.351,
    x2: 15,
    y2: 257.529,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_16",
    "data-name": "Unbenannter Verlauf 16",
    x1: 14.421,
    y1: 257.351,
    x2: 14.421,
    y2: 257.529,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_17",
    "data-name": "Unbenannter Verlauf 17",
    x1: 29.389,
    y1: 257.351,
    x2: 29.389,
    y2: 257.529,
    gradientTransform: "translate(-15.43 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_18",
    "data-name": "Unbenannter Verlauf 18",
    x1: 0,
    y1: 257.781,
    x2: 30,
    y2: 257.781,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_19",
    "data-name": "Unbenannter Verlauf 19",
    x1: 0,
    y1: 258.065,
    x2: 30,
    y2: 258.065,
    gradientTransform: "translate(0 -242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_20",
    "data-name": "Unbenannter Verlauf 20",
    x1: 0,
    y1: 259.315,
    x2: 30,
    y2: 259.315,
    gradientTransform: "translate(0 -243.289)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_21",
    "data-name": "Unbenannter Verlauf 21",
    x1: 0,
    y1: 260.562,
    x2: 30,
    y2: 260.562,
    gradientTransform: "translate(0 -244.575)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_22",
    "data-name": "Unbenannter Verlauf 22",
    x1: 0,
    y1: 261.815,
    x2: 30,
    y2: 261.815,
    gradientTransform: "translate(0 -245.867)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23",
    "data-name": "Unbenannter Verlauf 23",
    x1: 0,
    y1: 263.067,
    x2: 30,
    y2: 263.067,
    gradientTransform: "translate(0 -247.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_24",
    "data-name": "Unbenannter Verlauf 24",
    x1: 0,
    y1: 264.314,
    x2: 30,
    y2: 264.314,
    gradientTransform: "translate(0 -248.442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_25",
    "data-name": "Unbenannter Verlauf 25",
    x1: 0,
    y1: 265.563,
    x2: 30,
    y2: 265.563,
    gradientTransform: "translate(0 -249.729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_26",
    "data-name": "Unbenannter Verlauf 26",
    x1: 0,
    y1: 266.813,
    x2: 30,
    y2: 266.813,
    gradientTransform: "translate(0 -251.018)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_27",
    "data-name": "Unbenannter Verlauf 27",
    x1: 0,
    y1: 268.059,
    x2: 30,
    y2: 268.059,
    gradientTransform: "translate(0 -252.304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,6h30v18H0V6Z",
    style: {
      fill: "#0067c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12h30v6H0v-6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,14.98l.299.02.003-.044-.118-.008.009-.144.125-.091.004-.055-.132.096c-.004-.031-.022-.063-.053-.074-.027-.01-.061-.012-.085.008-.03.022-.036.062-.039.096l-.013.196h0ZM12.346,14.939l.01-.147c.004-.024.008-.052.029-.068.019-.013.048-.003.055.018.016.037.009.079.007.118l-.006.085-.095-.006h0ZM12.339,14.52l.292.068.066-.284-.041-.01-.056.242-.089-.021.051-.218-.041-.01-.051.218-.079-.018.054-.233-.042-.01-.064.276h0ZM12.444,14.128l.283.099.014-.041-.111-.039.044-.128c.01-.035.017-.077-.004-.109-.017-.024-.047-.04-.076-.039-.033,0-.059.025-.074.053-.021.04-.033.085-.049.127l-.027.077h0ZM12.499,14.101l.045-.128c.01-.022.023-.049.049-.056.021-.005.044.011.045.033.005.04-.012.078-.025.115l-.023.067-.091-.031ZM12.601,13.765l.16.093c.03.016.069.026.1.007.043-.024.07-.068.091-.111.017-.036.029-.081.008-.118-.023-.037-.065-.054-.1-.076l-.104-.061-.022.038.153.09c.024.015.044.041.04.071-.005.035-.025.066-.045.095-.017.023-.044.042-.074.036-.031-.006-.056-.026-.083-.041l-.102-.06-.022.037h0ZM12.817,13.412l.238.182.111-.145c.021-.031.041-.07.027-.108-.013-.03-.044-.053-.077-.055-.015-.002-.034.009-.042.014.008-.032-.018-.062-.047-.07-.035-.013-.071.01-.095.035-.028.03-.051.064-.076.096l-.039.051h0ZM12.877,13.403l.083-.107c.014-.015.035-.032.056-.021.019.008.024.033.015.05-.015.031-.039.057-.059.084l-.033.043-.062-.049h0ZM12.974,13.477l.087-.111c.016-.016.035-.037.06-.032.021.005.037.028.029.049-.012.039-.041.069-.065.102l-.037.049-.074-.057h0ZM13.087,13.094l.206.218.176-.167-.029-.031-.141.133-.004.003-.003-.003-.174-.184-.031.031ZM13.351,12.863l.183.238.036-.027-.183-.238-.036.027ZM13.62,12.68c-.03.018-.054.04-.072.065s-.028.051-.03.079.006.054.022.08c.014.023.035.042.059.055.025.013.051.018.08.015s.062-.016.098-.039c.035-.022.06-.047.075-.076.015-.027.019-.058.012-.088l-.041.016c.011.06-.028.089-.071.116-.068.041-.134.038-.174-.024-.042-.07.004-.128.062-.165.041-.025.081-.043.12-.018l.032-.029c-.022-.015-.048-.023-.077-.021-.03.002-.062.013-.095.034h0ZM13.974,12.503l-.031.336.047-.019.009-.104h0l.152-.061.079.068.047-.019-.256-.22-.047.019h0ZM14.015,12.538l.1.086-.112.045.012-.131h0ZM14.632,12.318l.019.299.162-.011c.043-.005.088-.016.117-.05.038-.042.043-.104.026-.156-.014-.046-.055-.08-.101-.089s-.092-.002-.138,0l-.085.007h0ZM14.678,12.358l.129-.007c.025,0,.049.007.069.021.03.021.048.057.044.094-.002.042-.033.08-.073.091-.023.006-.047.008-.071.01l-.084.005-.014-.214h0ZM15.05,12.3l-.017.3.292.017.002-.043-.248-.014.005-.091.223.013.002-.042-.223-.013.005-.081.239.014.002-.043-.282-.017h0ZM15.833,12.425l-.108.28.039.015.086-.222.004-.011.005.013.103.298.051.02.108-.28-.039-.015-.086.222-.004.011-.005-.013-.104-.297-.05-.021ZM16.236,12.598l-.136.267-.04-.02.136-.267.04.02ZM16.463,12.731c-.029-.019-.059-.032-.089-.038-.031-.006-.058-.004-.084.006-.025.01-.046.028-.063.053-.015.023-.024.049-.026.077-.002.028.005.054.02.079s.04.049.076.073c.034.023.068.035.1.037.031.002.06-.007.086-.026l-.032-.031c-.05.035-.092.012-.135-.016-.066-.044-.091-.106-.051-.168.046-.067.118-.05.176-.013.04.027.073.056.067.101l.04.017c.005-.027,0-.053-.013-.078-.016-.027-.039-.051-.072-.073h0ZM16.748,12.946l-.314.125.038.033.097-.039h0l.124.107-.025.102.038.033.08-.328-.038-.033h0ZM16.736,12.998l-.031.128-.091-.079.122-.049h0ZM16.975,13.155l-.231.191.028.034.091-.075.092.111-.029.151.035.043.03-.16c.026.021.064.032.095.015.027-.013.05-.037.051-.068.003-.041-.026-.075-.05-.106l-.112-.136ZM16.97,13.216l.097.12c.014.021.032.051.016.076-.014.021-.043.019-.061.006-.037-.025-.061-.063-.09-.096l-.037-.044.075-.062h0ZM17.326,13.632l-.337.015.025.044.105-.005h0l.082.142-.057.088.025.044.183-.284-.026-.044h0ZM17.297,13.677l-.072.111-.06-.104.132-.007h0ZM17.518,14.029c-.019-.051-.048-.103-.098-.128-.056-.028-.13-.014-.169.035-.034.041-.036.098-.027.149.011.058.037.112.077.156l-.022.008.014.04.141-.05-.055-.152-.032.012.04.112-.048.017c-.042-.036-.065-.089-.078-.142-.009-.04-.009-.088.021-.119.035-.036.096-.047.138-.017.041.03.064.079.076.127.008.032.007.07-.017.094-.007.005.004.012.006.018l.011.019c.026-.02.041-.051.04-.084,0-.033-.007-.065-.018-.095h0ZM17.604,14.263l-.168.033c-.031.006-.054.016-.07.029-.016.013-.025.032-.03.056-.005.024-.004.054.003.09h0c.007.037.018.065.031.086.014.021.03.034.049.041.019.006.045.007.076,0l.168-.033-.008-.043-.164.032c-.074.014-.098-.024-.111-.091h0c-.013-.067-.005-.112.069-.126l.164-.032-.009-.043h0ZM17.696,14.774l-.31-.133.004.05.096.041h0l.012.163-.089.054.004.05.288-.176-.005-.049h0ZM17.651,14.803l-.113.069-.009-.12.122.051h0ZM12.533,15.55l-.044.011.048.183.043-.011-.047-.183ZM17.468,15.55l.044.011-.048.183-.043-.011.047-.183ZM12.997,16.32l-.335.039.028.042.104-.012h0l.091.136-.051.091.028.042.163-.296-.028-.042ZM12.971,16.367l-.064.115-.067-.1.131-.015ZM13.125,16.503l-.214.2.029.031.18-.168-.095.26.033.035.258-.078-.177.165.029.031.214-.2-.043-.046-.263.078.098-.254-.049-.054ZM13.436,16.821l-.18.24.233.176.026-.034-.198-.149.055-.073.179.135.026-.034-.179-.135.049-.065.191.144.026-.034-.228-.171h0ZM13.73,17.036l-.141.265.039.021.056-.104.128.068.031.151.049.026-.033-.159c.032.01.071.005.093-.022.019-.021.032-.051.023-.079-.011-.039-.049-.06-.082-.078l-.163-.089h0ZM13.748,17.094l.136.074c.021.014.047.033.044.061-.002.025-.029.038-.051.032-.044-.007-.081-.033-.12-.053l-.054-.029.045-.085h0ZM14.069,17.213l-.113.278.042.017.113-.278-.042-.017ZM14.339,17.306c-.033-.011-.065-.016-.096-.014s-.058.011-.079.027c-.022.016-.038.039-.047.068-.009.026-.01.054-.005.081.006.027.019.051.04.071.021.02.052.037.092.051.039.013.074.016.106.009.031-.006.056-.022.076-.047l-.039-.022c-.039.047-.086.035-.135.02-.075-.026-.115-.078-.093-.149.027-.077.101-.078.166-.058.046.015.085.035.091.08l.043.006c-.002-.027-.013-.051-.033-.072-.02-.021-.049-.038-.087-.051h0ZM14.641,17.374l-.196.275.05.007.061-.085h0l.162.023.034.099.05.007-.11-.319-.051-.007ZM14.659,17.424l.043.125-.119-.017.076-.108h0ZM15.344,17.376c-.034.007-.064.018-.091.035-.026.017-.045.038-.056.063-.011.025-.014.052-.008.082.005.027.017.052.036.073.018.021.043.036.07.043.028.007.063.007.105,0,.04-.008.073-.022.097-.044.024-.021.038-.047.043-.078h-.045c-.011.06-.058.073-.108.083-.078.014-.139-.012-.154-.085-.014-.08.049-.118.117-.132.047-.009.091-.011.118.026l.041-.015c-.015-.023-.038-.039-.064-.047-.028-.01-.062-.011-.101-.003h0ZM15.544,17.34l.085.288.28-.083-.012-.041-.238.071-.026-.088.215-.064-.012-.041-.215.064-.023-.077.229-.068-.012-.041-.271.08ZM15.869,17.238l.126.272.038-.017-.105-.227.291.134c.006.006.013.002.019-.002l.038-.017-.126-.272-.038.017.105.227-.298-.137-.05.022h0ZM16.198,17.084l.023.036.107-.07.004-.003.002.003.139.212.036-.024-.139-.212-.002-.003.004-.003.108-.071-.024-.036-.258.171ZM16.5,16.877l.203.221.032-.03-.08-.087.106-.098.153.02.041-.038-.161-.021c.02-.027.028-.065.01-.095-.014-.026-.04-.048-.07-.048-.041,0-.073.03-.103.056l-.131.12h0ZM16.561,16.879l.114-.104c.02-.015.049-.035.075-.02.022.012.022.042.009.061-.023.038-.059.064-.091.095l-.042.039-.065-.071ZM16.849,16.528l.134.31.032-.039-.042-.096h0l.104-.127.102.022.032-.039-.33-.07-.032.039h0ZM16.902,16.538l.129.028-.076.093-.053-.121h0ZM16.98,16.358l.252.163.132-.204-.036-.023-.106.163-.003.004-.003-.002-.213-.138-.023.037Z",
    style: {
      fill: "#c8a400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 12.791 13.089 16.101 16.911 16.101 15 12.791",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.792l-.944,1.636-.463.801h2.814l-.441-.765-.966-1.672h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.792l-.071.122.071,1.65.071-1.649-.071-.123Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.564h-.004l-.071-1.65h0l.073-.126.073.126h0s-.071,1.65-.071,1.65ZM14.931,12.915l.069,1.604.069-1.604-.069-.119-.069.119Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.324h-.004l.004.094.004-.093h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.685,14.016l-.138-.029-1.547.577,1.59-.442.095-.106Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001,14.566v-.004s1.546-.577,1.546-.577h0l.142.03-.002.002-.095.106h0l-1.591.443ZM16.547,13.989l-1.504.561,1.546-.43.092-.102-.134-.029Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.228,14.49v-.004s-.089.033-.089.033l.09-.025v-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.041,15.997l-.015-.141-1.026-1.292.912,1.376.129.057Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.044,16.001h-.003s-.13-.059-.13-.059h0l-.912-1.376.003-.002,1.027,1.293.015.144ZM15.914,15.938l.126.056-.014-.137-.998-1.257.886,1.338Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.141,14.758l.003-.002-.058-.073.052.078.003-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.959,15.997l.129-.057.912-1.376-1.027,1.293-.014.14Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.956,16.001l.015-.145h0l1.027-1.293.003.002-.913,1.376h-.001l-.131.06ZM13.975,15.858l-.014.137.126-.056.887-1.338-.999,1.257Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.859,14.758l.003.002.052-.078-.058.073.003.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.315,14.016l.095.105,1.59.442-1.547-.577-.138.03Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.566l-1.591-.443h0l-.097-.108h.003s.139-.031.139-.031h.001l1.547.577-.002.005ZM13.411,14.12l1.546.43-1.504-.561-.134.029.092.102Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.772,14.49v.004s.089.025.089.025l-.088-.033v.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.247,12.81l-.087.111-.16,1.643.3-1.623-.053-.131Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.564h-.004l.16-1.644h0l.089-.114.054.135h0s-.299,1.623-.299,1.623ZM15.161,12.922l-.155,1.598.291-1.578-.052-.128-.084.108Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.033,14.327h-.004l-.009.093.017-.092h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.745,14.256l-.133-.048-1.612.356,1.637-.217.108-.091Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.566v-.004l1.613-.356h0l.136.049-.003.002-.109.091h0l-1.637.218ZM16.612,14.21l-1.567.346,1.591-.211.105-.088-.129-.047Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.236,14.522v-.004s-.092.02-.092.02l.093-.012v-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.832,16.128l.005-.141-.837-1.423.712,1.489.12.075Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.834,16.132l-.003-.002-.12-.075h0s-.712-1.49-.712-1.49l.003-.002.837,1.424h0s-.005.145-.005.145ZM15.713,16.052l.117.073.005-.137-.814-1.384.692,1.448Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.113,14.776l.004-.002-.047-.081.04.084h.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.769,15.839l.136-.039,1.095-1.236-1.197,1.137-.034.138Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.767,15.841v-.003s.035-.138.035-.138h0l1.197-1.137.003.003-1.095,1.236h-.001l-.139.039ZM13.805,15.702l-.033.133.132-.038,1.065-1.201-1.164,1.106Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.833,14.736l.003.003.062-.07-.068.064.003.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.408,13.787l.079.117,1.513.66-1.451-.787-.141.01Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,14.566l-1.514-.66h0l-.081-.12.145-.01h0l1.451.787v.003ZM13.488,13.903l1.471.641-1.411-.765-.137.01.077.114Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.785,14.459l-.002.004.086.037-.082-.045-.002.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.488,12.861l-.102.098-.386,1.605.523-1.566-.035-.137Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.565h-.004s.387-1.606.387-1.606l.105-.101v.003s.035.138.035.138h0s-.523,1.566-.523,1.566ZM15.388,12.96l-.376,1.56.508-1.523-.033-.133-.099.096Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.066,14.334h-.004s-.022.09-.022.09l.03-.089h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.771,14.502l-.125-.066-1.646.128,1.651.013.12-.075Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.651,14.579h0l-1.651-.013v-.004l1.646-.128h0l.128.068-.123.077ZM15.045,14.562l1.605.013.117-.073-.121-.065-1.601.125Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24,14.556v-.004l-.093.007h.093s0-.003,0-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.606,16.229l.025-.139-.631-1.526.498,1.574.108.091Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.607,16.233l-.111-.093h0s-.498-1.575-.498-1.575h.004s.631,1.525.631,1.525h0l-.026.143ZM15.499,16.137l.105.088.024-.135-.613-1.483.484,1.53Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.082,14.789h.004s-.036-.087-.036-.087l.028.089.004-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.604,15.655l.14-.02,1.256-1.071-1.343.96-.053.131Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.601,15.657l.054-.135h0l1.343-.96.002.003-1.257,1.071h-.001l-.141.021ZM13.658,15.525l-.052.128.136-.019,1.221-1.042-1.305.933Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.811,14.712l.003.003.071-.061-.076.054.002.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.531,13.573l.062.127,1.407.864-1.328-.981-.141-.01Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,14.566l-1.407-.864h0s-.063-.131-.063-.131l.145.01h0l1.328.981-.003.004ZM13.595,13.699l1.368.84-1.291-.954-.137-.01.06.124Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.801,14.43l-.002.003.08.049-.075-.056-.003.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.721,12.945l-.114.083-.607,1.536.735-1.478-.014-.141Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.565l-.004-.002.606-1.536h0l.117-.085.015.145h0l-.734,1.478ZM15.608,13.03l-.589,1.493.715-1.437-.014-.137-.112.081Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.098,14.345l-.004-.002-.034.087.042-.084h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.762,14.749l-.114-.083-1.648-.102,1.633.243.129-.058Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.633,14.809h0l-1.633-.243v-.004l1.648.102h0l.117.085-.132.06ZM15.045,14.569l1.588.236.126-.056-.111-.081-1.603-.099Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.238,14.589v-.004l-.093-.006.092.014v-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.368,16.297l.044-.134-.412-1.599.274,1.628.094.105Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.369,16.301l-.002-.003-.095-.105h0s-.274-1.629-.274-1.629h.004s.412,1.598.412,1.598h0s-.045.139-.045.139ZM15.276,16.191l.092.102.042-.131-.401-1.554.267,1.583Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.05,14.799h.004s-.023-.091-.023-.091l.015.092h.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.466,15.45h.141l1.393-.886-1.464.763-.07.123Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.608,15.452h-.145l.002-.003.071-.123h0l1.464-.763.002.003-1.394.886ZM13.469,15.448h.137l1.354-.861-1.423.742-.068.119Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.792,14.684l.002.003.079-.05-.083.043.002.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.683,13.378l.044.134,1.273,1.052-1.178-1.156-.139-.03Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,14.565l-1.273-1.051h0s-.045-.139-.045-.139h.003s.139.03.139.03h0l1.178,1.156-.002.004ZM13.729,13.512l1.238,1.022-1.146-1.124-.134-.029.042.131Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.822,14.404l-.003.003.072.059-.067-.065-.002.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.939,13.061l-.125.066-.814,1.437.934-1.361.005-.142Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.565l-.003-.002.814-1.437h0l.128-.068-.005.145h0l-.934,1.362ZM15.815,13.129l-.792,1.396.908-1.324.005-.137-.121.065Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.127,14.361l-.003-.002-.046.081.053-.077-.004-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.719,14.993l-.102-.098-1.617-.331,1.583.468.136-.039Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.583,15.034h0l-1.584-.468v-.004s1.619.331,1.619.331l.105.101-.14.04ZM15.044,14.575l1.539.455.132-.038-.099-.096-1.572-.321Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.233,14.622v-.004s-.091-.019-.091-.019l.09.026v-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.124,16.331l.062-.127-.186-1.64.045,1.65.079.117Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.124,16.335l-.081-.12h0s-.045-1.651-.045-1.651h.004l.186,1.641h0l-.064.13ZM15.046,16.214l.077.114.06-.124-.18-1.595.043,1.605Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.017,14.803h.004l-.011-.093.003.093h.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.357,15.228l.14.02,1.503-.684-1.556.552-.087.112Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.498,15.249h0l-.144-.02.089-.115h.001l1.556-.552v.004s-1.502.683-1.502.683ZM13.361,15.226l.136.019,1.461-.664-1.513.537-.084.108Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.778,14.654l.002.004.085-.039-.088.031v.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.861,13.207l.025.139,1.114,1.218-1.006-1.309-.133-.048Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,14.565l-1.115-1.218h0s-.025-.144-.025-.144l.137.05h0l1.006,1.309-.003.003ZM13.888,13.345l1.083,1.184-.978-1.273-.129-.047.024.136Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.846,14.38l-.003.003.063.069-.057-.074-.003.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.139,13.207l-.133.048-1.006,1.309,1.114-1.218.025-.139Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001,14.565l-.003-.002,1.006-1.309h0l.136-.049-.025.143h0l-1.115,1.217ZM16.007,13.257l-.978,1.273,1.083-1.184.024-.135-.129.046Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.154,14.38l-.003-.003-.057.074.063-.069-.003-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.643,15.228l-.087-.111-1.556-.553,1.503.683.14-.019Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.502,15.249h0l-1.503-.684v-.004s1.557.552,1.557.552h0l.089.114-.143.022ZM15.042,14.581l1.461.664.136-.019-.085-.108-1.512-.537Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.222,14.654v-.004s-.087-.031-.087-.031l.085.039.002-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.876,16.331l.079-.117.045-1.65-.186,1.64.062.127Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.876,16.335v-.003s-.063-.128-.063-.128h0s.186-1.641.186-1.641h.004l-.045,1.651h0l-.082.121ZM14.816,16.204l.06.124.077-.114.043-1.605-.18,1.595Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.983,14.803h.004l.003-.093-.011.093h.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.281,14.993l.136.039,1.583-.468-1.617.33-.102.099Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.417,15.034h0l-.14-.04.002-.002.102-.099h.001l1.617-.33v.004s-1.582.467-1.582.467ZM13.285,14.992l.132.038,1.539-.455-1.573.321-.098.096Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.767,14.622v.004s.091-.026.091-.026l-.092.019v.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.061,13.061l.005.141.934,1.362-.814-1.436-.125-.067Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998,14.565l-.934-1.362h0s-.005-.146-.005-.146l.128.068h0l.814,1.436-.003.004ZM14.068,13.202l.908,1.324-.791-1.396-.121-.065.004.137Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.873,14.361l-.003.002.053.077-.046-.081-.004.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.317,13.378l-.138.029-1.179,1.157,1.273-1.051.044-.135Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001,14.565l-.003-.003,1.179-1.157h0l.142-.03v.003s-.045.135-.045.135h0l-1.274,1.052ZM16.179,13.41l-1.146,1.124,1.238-1.022.043-.131-.135.029Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.178,14.404l-.003-.003-.067.065.072-.059-.002-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.534,15.45l-.071-.122-1.463-.764,1.393.886h.141Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.538,15.452h-.145l-1.393-.886.002-.003,1.464.764h0l.072.125ZM16.394,15.448h.138l-.069-.119-1.423-.742,1.354.861Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.208,14.684l.002-.004-.083-.043.079.05.002-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.632,16.297l.095-.105.273-1.628-.412,1.599.044.134Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.631,16.301l-.045-.138h0l.412-1.599h.004s-.274,1.63-.274,1.63h0l-.097.107ZM14.59,16.162l.042.131.092-.102.266-1.583-.4,1.554Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95,14.799h.004s.015-.091.015-.091l-.023.09h.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.238,14.749l.129.057,1.633-.242-1.648.102-.114.083Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.367,14.809h0l-.133-.059.003-.002.115-.083h.001l1.647-.103v.004l-1.633.243ZM13.242,14.749l.126.056,1.588-.236-1.602.099-.112.081Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.762,14.589v.004s.093-.014.093-.014l-.093.006v.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.279,12.945l-.015.141.736,1.478-.606-1.536-.115-.083Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998,14.565l-.736-1.478.015-.145.118.085h0s.606,1.536.606,1.536l-.003.002ZM14.267,13.086l.715,1.437-.589-1.493-.111-.081-.015.137Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.903,14.345l-.004.002.042.084-.034-.087h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.469,13.573l-.141.01-1.328.981,1.407-.864.062-.127Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001,14.566l-.002-.003,1.328-.981h0l.144-.01-.064.131h0l-1.407.863ZM16.329,13.585l-1.291.954,1.368-.84.06-.124-.137.01Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.199,14.43l-.002-.003-.075.056.08-.049-.003-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.396,15.655l-.053-.131-1.343-.96,1.256,1.071.14.02Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.399,15.657l-.144-.02h0l-1.256-1.071.002-.003,1.344.96h0s.054.134.054.134ZM16.257,15.633l.136.019-.052-.128-1.306-.933,1.222,1.042Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.189,14.712l.002-.003-.076-.054.071.061.003-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.394,16.229l.108-.091.498-1.574-.631,1.526.025.139Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.393,16.233l-.025-.143h0s.631-1.527.631-1.527h.004s-.498,1.576-.498,1.576h0l-.112.094ZM14.371,16.09l.024.135.105-.088.484-1.53-.613,1.483Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,14.789h.004s.028-.088.028-.088l-.036.086.004.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.229,14.502l.12.075,1.651-.013-1.646-.128-.125.066Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.349,14.579h0l-.123-.077.003-.002.125-.067h.001l1.645.129v.004l-1.651.013ZM13.233,14.502l.117.073,1.605-.013-1.6-.125-.122.065Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.76,14.556v.004h.093s-.093-.008-.093-.008v.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.512,12.861l-.034.137.522,1.566-.387-1.605-.101-.098Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998,14.565l-.523-1.566h0s.035-.141.035-.141l.105.101h0l.387,1.605h-.004ZM14.479,12.998l.508,1.523-.376-1.56-.099-.095-.033.132Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.934,14.334h-.004s.03.09.03.09l-.022-.091h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.592,13.787l-.141-.01-1.451.787,1.513-.659.079-.118Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001,14.566l-.002-.003,1.452-.787h0l.144.01-.081.12h0l-1.513.66ZM16.452,13.779l-1.411.765,1.471-.641.077-.114-.137-.01Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.216,14.459l-.002-.004-.082.045.086-.037-.002-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.231,15.839l-.034-.137-1.197-1.138,1.095,1.236.136.039Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.234,15.841h-.003s-.136-.04-.136-.04h0l-1.095-1.236.003-.003,1.197,1.138h0s.034.141.034.141ZM16.096,15.798l.132.038-.033-.133-1.163-1.106,1.064,1.201Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167,14.736l.003-.003-.068-.064.062.07.003-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.168,16.128l.12-.075.712-1.489-.837,1.423.005.141Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166,16.132l-.005-.145h0l.837-1.423.003.002-.712,1.49h0l-.123.076ZM14.165,15.988l.005.137.117-.073.692-1.448-.814,1.384Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.887,14.776l.004.002.04-.084-.047.081h.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.255,14.256l.108.091,1.637.217-1.612-.356-.133.048Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.566l-1.637-.217h0l-.111-.093.137-.05h.001l1.61.356v.004ZM13.364,14.345l1.591.211-1.567-.346-.129.047.105.088Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.764,14.522v.004s.092.012.092.012l-.091-.02v.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.753,12.81l-.053.131.3,1.623-.16-1.643-.087-.111Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998,14.564l-.3-1.624h0l.054-.134.089.115h0s.16,1.644.16,1.644h-.003ZM14.702,12.941l.291,1.578-.155-1.598-.085-.108-.051.128Z",
    style: {
      fill: "#17c0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.967,14.327h-.004s.017.093.017.093l-.009-.093h-.004Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.975c-.319,0-.628.114-.869.322l-.44.762c-.015.082-.023.164-.023.247h.151c0-.652.529-1.18,1.18-1.18s1.18.529,1.18,1.18h.151c0-.083-.007-.166-.022-.247l-.44-.762c-.24-.208-.549-.322-.868-.322Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14c-.353,0-.673.14-.908.367l-.361.625c-.026.103-.038.209-.038.315h.128c0-.652.529-1.18,1.18-1.18s1.18.529,1.18,1.18h.127c0-.109-.013-.215-.038-.316l-.361-.624c-.236-.227-.556-.367-.909-.367h0Z",
    style: {
      fill: "#f60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.024c-.381,0-.723.166-.958.429l-.262.453c-.042.13-.064.265-.064.401h.103c0-.652.529-1.18,1.18-1.18s1.18.529,1.18,1.18h.103c0-.14-.022-.275-.064-.401l-.262-.453c-.233-.263-.575-.429-.956-.429h0Z",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.047c-.436,0-.821.222-1.047.56l-.084.146c-.085.172-.129.362-.128.554h.08c0-.652.529-1.18,1.18-1.18s1.18.529,1.18,1.18h.08c0-.192-.044-.381-.128-.553l-.085-.148c-.228-.337-.612-.558-1.048-.559h0Z",
    style: {
      fill: "lime"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.072c-.682,0-1.236.553-1.236,1.236h.055c0-.652.529-1.18,1.18-1.18s1.18.529,1.18,1.18h.055c.002-.683-.552-1.236-1.234-1.236Z",
    style: {
      fill: "#0cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.095c-.669,0-1.211.543-1.211,1.212h.04c0-.647.524-1.171,1.171-1.171s1.171.524,1.171,1.171h.041c0-.669-.543-1.212-1.212-1.212Z",
    style: {
      fill: "blue"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14.12c-.656,0-1.188.532-1.188,1.188v.022h.024v-.022c0-.643.521-1.164,1.164-1.164s1.164.521,1.164,1.164v.022h.024v-.022c0-.657-.532-1.188-1.188-1.188Z",
    style: {
      fill: "purple"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.012,14.644c-.019-.004-.037-.015-.053-.018-.023.022-.025.044-.022.062.008.004.009.011.026.026s.015.023.014.059c0,.015.002.047.017.05.016.003.028-.01.033-.035.005-.024.013-.036.021-.051.009-.055-.006-.075-.036-.093h0Z",
    style: {
      fill: "#510000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.915,14.506c-.018,0-.046.03-.058.014-.007-.009-.008-.027-.001-.042.017-.035.034-.051.065-.07.071-.042.117-.029.152.032.033.053.065.112.067.161.001.015.008.042-.005.056-.04.042-.138-.043-.195-.03-.019.005-.041.018-.059.007-.014-.009-.002-.03.008-.039.018-.016.045-.071.041-.095-.001-.013-.002.005-.015.006h0Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.908,14.476c-.032.013-.029.032-.045.048.005.002.023.009.041-.009.008-.006.016-.009.02-.011-.009.007-.016.017-.021.021-.012.01-.031.032-.04.055s-.013.05-.011.053.013.023.047.037c.061.024.073.073.134.073.048,0,.041-.032.079-.025.034.006.051-.021.019-.037-.041-.014-.123-.006-.161,0-.012-.122-.002-.079-.005-.132-.003-.053-.019-.056.002-.098-.016.026-.037.022-.059.024h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.028,14.394c-.001.007-.002.015-.002.018l.008.03c.003.01.005.017.007.028s.012.015.021.022c.011.008.003.031.009.032s.015-.032.015-.037c0-.006,0-.013-.001-.019-.004-.009-.008-.018-.013-.026-.002-.003-.004-.007-.006-.01-.007-.01-.015-.018-.024-.026h-.002s-.008-.007-.008-.007l-.004-.005h0Z",
    style: {
      fill: "#ff2a2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.037,14.622c-.022-.006-.043-.016-.061-.022-.036-.011-.074-.034-.101-.024-.01.004-.009.014-.012.027-.001.016-.018.04-.004.032.021-.012.075.022.093.033.009.005.027.016.032.031.006.015.003.053.001.069-.002.017.004.055.021.06.018.005.032-.01.039-.037.007-.026.012-.042.023-.057.011-.016.023-.023.04-.026s.041.014.041-.006c0-.013-.012-.026-.007-.044.004-.014-.012-.011-.025-.017-.03-.01-.058-.013-.08-.019h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.951,14.667c-.01-.005-.069-.044-.091-.032-.007.004-.01,0-.01-.008,0-.007.003-.018.006-.026.002-.008.006-.024.015-.032.021-.017.068.017.093.027l-.013.071h0Z",
    style: {
      fill: "#910000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.053,14.741c.027-.048.045-.042.078-.041.011,0,.014-.01.012-.02-.008.019-.05-.002-.072.008-.047.021-.038.113-.061.122.023.019.034-.053.043-.069h0Z",
    style: {
      fill: "#ff3a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.593,15.229l-.299.517h3.411l-.299-.517h-2.813Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M13.491,15.641c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092.001-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h1",
    "data-name": "h",
    d: "M13.491,15.608c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092,0-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h2",
    "data-name": "h",
    d: "M13.491,15.574c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092.001-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h3",
    "data-name": "h",
    d: "M13.491,15.541c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046-.001-.092,0-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h4",
    "data-name": "h",
    d: "M13.491,15.507c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092,0-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h5",
    "data-name": "h",
    d: "M13.491,15.474c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092,0-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h6",
    "data-name": "h",
    d: "M13.491,15.44c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092,0-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h7",
    "data-name": "h",
    d: "M13.491,15.407c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092.001-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h8",
    "data-name": "h",
    d: "M13.491,15.373c-.05,0-.096.005-.141.011l-.015.025.214-.021c.099.002.188.025.294.025h.136c.105,0,.195-.023.293-.025.099.002.189.025.294.025h.136c.105,0,.194-.023.293-.025.099.002.188.025.293.025h.136c.105,0,.195-.023.294-.025.099.002.188.025.293.025h.136c.105,0,.194-.023.293-.025.076.002.148.016.225.022l-.015-.027-.131-.01c-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.294-.025-.045,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.189-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.194.022-.293.025-.099-.002-.188-.025-.293-.025-.046,0-.091,0-.136,0-.105,0-.195.022-.294.025-.099-.002-.188-.025-.293-.025-.046,0-.092.001-.137,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.597,15.224l-.004.006h2.814l-.004-.006h-2.806ZM13.59,15.235l-.004.007h2.827l-.004-.007h-2.819ZM13.584,15.245l-.006.011h2.844l-.006-.011h-2.832ZM13.575,15.262l-.007.013h2.866l-.007-.013h-2.852ZM13.563,15.283l-.007.013h2.889l-.007-.013h-2.875ZM13.551,15.303l-.007.013h2.913l-.007-.013h-2.899ZM13.539,15.324l-.007.013h2.937l-.008-.013h-2.922ZM13.526,15.346l-.009.016h2.966l-.009-.016h-2.948ZM13.721,15.369c.104.02.113,0,.113,0h-.113ZM16.166,15.369s.01.02.113,0h-.113Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.919,14.911c-.051,0-.067.026-.067.026-.082.317-.354.64-.678.64h-.242v.323h1.845l-.186-.329c-.291-.043-.529-.341-.605-.634,0,0-.016-.026-.067-.026h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.919,14.924c-.024,0-.038.005-.046.011-.008.005-.009.008-.01.009h-.001c-.042.16-.131.32-.25.441-.12.122-.272.205-.438.205h-.23v.298h1.826l-.17-.302c-.141-.018-.269-.095-.374-.201-.12-.121-.208-.282-.25-.441h-.001s-.002-.003-.01-.008c-.008-.006-.023-.012-.046-.012h0Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.919,14.924s.008,0,.012,0v.324c-.001.07-.025.127-.06.193-.016.047-.03.029-.07.086-.055.02-.096.027-.154.036-.076.012-.244.023-.327.004.109-.032.209-.098.293-.184.023-.023.044-.047.064-.072.034-.042.064-.087.09-.134.011-.019.021-.037.03-.057.014-.029.026-.058.038-.088.004-.01.007-.02.011-.03.007-.02.013-.04.018-.06h0s.002-.004.01-.009c.005-.003.011-.006.017-.007h.001c.006-.002.015-.003.027-.003h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.898,14.967c-.012.181-.068.396-.199.534-.048.04-.11.077-.169.068.203-.165.326-.418.368-.602Z",
    style: {
      fill: "#c6cb24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.735,15.278c-.03.082-.144.202-.265.301-.035,0-.053.003-.084,0,.074-.006.246-.152.349-.302h0Z",
    style: {
      fill: "#9ecb34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.459,14.911c-.051,0-.067.026-.067.026-.082.317-.354.64-.678.64h-.242v.323h1.845l-.186-.329c-.291-.043-.529-.341-.605-.634,0,0-.016-.026-.067-.026h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.459,14.924c-.024,0-.038.005-.046.011-.008.005-.009.008-.01.009h-.001c-.042.16-.131.32-.25.441-.12.122-.272.205-.438.205h-.23v.298h1.826l-.17-.302c-.141-.018-.269-.095-.374-.201-.12-.121-.208-.282-.25-.441h-.001s-.002-.003-.01-.008c-.009-.006-.023-.012-.046-.012h0Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.459,14.924s.008,0,.012,0v.324c-.001.07-.025.127-.06.193-.016.047-.03.029-.07.086-.055.02-.096.027-.154.036-.076.012-.244.023-.327.004.109-.032.209-.098.293-.184.023-.023.044-.047.064-.072.034-.042.064-.087.09-.134.011-.019.021-.037.03-.057.014-.029.026-.058.038-.088.004-.01.007-.02.011-.03.007-.02.013-.04.018-.06h0s.002-.004.01-.009c.005-.003.011-.006.017-.007h.001c.006-.002.015-.003.027-.003h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.438,14.967c-.012.181-.068.396-.199.534-.048.04-.11.077-.169.068.202-.165.326-.418.368-.602Z",
    style: {
      fill: "#c6cb24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.275,15.278c-.03.082-.144.202-.265.301-.035,0-.053.003-.084,0,.073-.006.246-.152.349-.302h0Z",
    style: {
      fill: "#9ecb34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.067,14.937c.082.317.354.64.677.64h.243v.323h-1.974v-.323s.241,0,.241,0c.324,0,.596-.323.678-.64,0,0,.016-.026.067-.026.052,0,.068.026.068.026h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,14.924c.024,0,.038.006.046.011.008.005.01.008.01.008h.001c.042.16.13.32.25.441.121.122.273.205.439.205h.229v.298h-1.949v-.298h.23c.166,0,.318-.083.438-.205.119-.121.208-.281.25-.441h.001s.002-.004.01-.009c.007-.005.022-.01.045-.01Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.978,14.926s-.005,0-.007.002h0c-.006.002-.012.004-.017.007-.008.005-.009.008-.01.009h-.001l-.018.06-.011.03-.037.088c-.009.019-.019.038-.03.057-.026.047-.057.092-.09.134-.02.025-.041.049-.064.072-.084.086-.184.151-.293.184.083.018.121-.002.196-.014.059-.009.126-.017.181-.037.041-.057.027-.039.043-.086.035-.067.087-.127.1-.2.05-.09.059-.258.059-.306h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.978,14.967c-.012.181-.068.396-.199.534-.048.04-.11.077-.169.068.203-.165.326-.418.368-.602Z",
    style: {
      fill: "#c6cb24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.815,15.278c-.03.082-.144.202-.265.301-.034,0-.053.003-.084,0,.074-.006.246-.152.349-.302h0Z",
    style: {
      fill: "#9ecb34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.029,14.927h0c.007.002.012.004.018.007.008.005.009.008.01.009h.001s.018.061.018.061l.011.03.037.088.03.057c.026.047.057.092.09.134.02.025.041.049.064.072.084.086.184.163.293.195-.217,0-.312-.019-.391-.12-.079-.102-.108-.146-.124-.208s-.062-.197-.057-.325h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044,14.967c.012.181.067.36.198.499.048.04.11.076.169.068-.22-.151-.325-.383-.367-.567h0Z",
    style: {
      fill: "#c6cb24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.542,14.911c-.051,0-.067.026-.067.026-.076.292-.355.67-.645.714l-.144.249h1.47v-.34c-.265-.071-.477-.349-.547-.623,0,0-.015-.026-.067-.026h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.542,14.924c-.024,0-.038.006-.046.011-.008.005-.01.008-.01.008h-.001c-.042.16-.14.321-.242.45s-.292.258-.421.272l-.128.222h1.442v-.321c-.107-.033-.204-.098-.287-.182-.119-.121-.208-.281-.25-.441h-.001s-.002-.004-.01-.009c-.008-.005-.022-.01-.046-.01h0Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.503,14.967c-.019.271-.17.614-.34.673-.056.019-.153.026-.187.03.299-.142.475-.476.527-.703Z",
    style: {
      fill: "#93bc30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.542,14.924s-.008,0-.012,0v.324c.001.07.025.127.06.193.002.006.004.011.006.015.012.033.021.044.068.08.15.114.335.131.444.121-.034-.027-.071-.051-.103-.074.051-.002.101-.008.135-.015-.109-.032-.209-.098-.293-.184-.015-.015-.029-.031-.042-.047l-.018-.024c-.034-.042-.068-.088-.094-.135-.011-.019-.021-.038-.03-.057-.019-.038-.035-.078-.048-.118-.007-.02-.012-.04-.018-.06h-.001s-.002-.004-.01-.009c-.005-.003-.011-.006-.017-.007h-.001c-.007-.003-.016-.004-.026-.004h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.563,14.967c.012.181.068.396.199.534.048.04.11.077.169.068-.202-.165-.325-.418-.368-.602Z",
    style: {
      fill: "#ccd11e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688,15.217c.071.175.251.339.436.449.034,0,.045,0,.076-.002-.132-.071-.345-.172-.512-.447Z",
    style: {
      fill: "#9ecb34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.08,14.911c-.051,0-.067.026-.067.026-.076.292-.355.67-.645.714l-.144.249h1.47v-.34c-.265-.071-.477-.349-.547-.623,0,0-.016-.026-.067-.026h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.08,14.924c-.024,0-.038.006-.046.011-.008.005-.01.008-.01.008h-.001c-.042.16-.14.321-.242.45s-.292.258-.421.272l-.128.222h1.442v-.321c-.107-.033-.204-.098-.287-.182-.119-.121-.208-.281-.25-.441h-.001s-.002-.004-.01-.009c-.009-.005-.023-.01-.046-.01h0Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04,14.967c-.019.271-.17.614-.34.673-.056.019-.153.026-.187.03.299-.142.475-.476.527-.703Z",
    style: {
      fill: "#93bc30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.079,14.924s-.008,0-.012,0v.324c.001.07.025.127.06.193.002.006.004.011.006.015.012.033.021.044.068.08.15.114.335.131.444.121-.034-.027-.071-.051-.103-.074.051-.002.101-.008.135-.015-.109-.032-.209-.098-.293-.184-.015-.015-.029-.031-.042-.047l-.018-.024c-.034-.042-.068-.088-.094-.135-.011-.019-.021-.038-.03-.057-.019-.038-.035-.078-.048-.118-.007-.02-.012-.04-.018-.06h-.001s-.002-.004-.01-.009c-.005-.003-.011-.006-.017-.007h-.001c-.006-.003-.016-.004-.026-.004h0Z",
    style: {
      fill: "#ede71f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,14.967c.012.181.068.396.199.534.048.04.11.077.169.068-.202-.165-.325-.418-.368-.602Z",
    style: {
      fill: "#c6cb24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.225,15.217c.071.175.251.339.436.449.034,0,.045,0,.076-.002-.132-.071-.345-.172-.512-.447Z",
    style: {
      fill: "#9ecb34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.695,15.741c-.017.006-.133-.006-.193,0l-.038.01c-.034,0-.067,0-.1,0-.108,0-.199.028-.302.028s-.194-.028-.302-.028c-.034,0-.067,0-.1,0-.108,0-.199.028-.302.028s-.194-.028-.302-.028c-.034,0-.067,0-.1,0-.108,0-.199.028-.302.028s-.194-.028-.302-.028h-.1c-.108,0-.199.029-.302.028-.103,0-.194-.028-.302-.028h-.1c-.086,0-.187.018-.268.026l-.188.326h3.82l-.217-.361Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.44,15.693h-.018c-.097.003-.167.033-.336.033s-.187-.031-.378-.026c-.178.004-.253.038-.35.036s-.254-.021-.375-.008-.265.039-.359.039c-.117,0-.235-.022-.357-.01-.123.012-.18.045-.332.045-.131,0-.272-.021-.382-.021-.103,0-.218.029-.303.043l-.025.044c.067-.008.257-.036.324-.038.07-.002.322.014.46.01.139-.005.155-.035.319-.035.114,0,.2.012.317.012.073,0,.139-.037.25-.037l.084-.003c.094-.015.252,0,.361.007.099.005.164-.018.267-.022l.134-.004c.104-.003.193.019.29.019.097-.006.192-.028.296-.031l.135-.004c.069-.002.175.002.248.015l-.025-.043c-.071-.004-.159-.021-.245-.021h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M13.509,16.042c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.026.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044,0-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m1",
    "data-name": "m",
    d: "M13.509,16.004c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.025.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044-.001-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m2",
    "data-name": "m",
    d: "M13.509,15.965c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.025.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044,0-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m3",
    "data-name": "m",
    d: "M13.509,15.926c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.025.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044,0-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m4",
    "data-name": "m",
    d: "M13.509,15.888c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.026.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044-.002-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m5",
    "data-name": "m",
    d: "M13.509,15.849c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.026.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044,0-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m6",
    "data-name": "m",
    d: "M13.509,15.811c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.026.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044-.002-.089,0-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m7",
    "data-name": "m",
    d: "M13.509,15.772c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.026.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.096.008c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09.001-.135,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m8",
    "data-name": "m",
    d: "M13.509,15.733c-.104,0-.192.026-.29.028-.036,0-.071-.005-.106-.01l-.015.025.045.002h.134c.104,0,.191-.026.289-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.187.028.291.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.289.028h.135c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134c.104,0,.192-.026.29-.028.098.003.186.028.29.028h.134l.053-.002-.014-.024-.097.009c-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.135,0-.104,0-.192.026-.289.028-.098-.003-.186-.028-.29-.028-.045,0-.09,0-.134,0-.104,0-.192.026-.29.028-.098-.003-.186-.028-.29-.028-.044,0-.089.001-.134,0h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.315,15.741l-.073.126c.085-.014.213-.051.319-.051.11,0,.242.027.373.028.152,0,.209-.032.332-.045.123-.012.24.016.357.016.094,0,.238-.033.359-.045.121-.013.232.009.378.011s.169-.035.347-.039c.191-.004.208.026.378.026.127.007.236-.026.35-.034s.166,0,.249.003l-.055-.098h-.003l-3.037.067-.274.035Z",
    style: {
      fill: "#97c924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.502,15.739l.115.008c.03.003.059.005.089.008l-.011-.015c-.017.007-.133-.005-.193,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.746l-.964,1.671-.986,1.707h3.9l-.965-1.67-.985-1.708ZM15,12.836l.946,1.64.925,1.603h-3.744l.947-1.639.926-1.604Z",
    style: {
      fill: "#c8a400"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/NI.ea4617b0e2660d9608a023d4c759f54a.svg";
export { ForwardRef as ReactComponent };